export default __webpack_public_path__ + "static/shirlee turner-71b9af82841c53783742d51e70c7bbc5.webp";